module.exports = __webpack_public_path__ + "static/media/chart-line-down.d5e43792.svg";